import BaseCommunication from "../../Communication/BaseCommunication";
import store from "../../Redux/store";
import {
	API_URL,
	API_BASE_URL,
	HttpMethod,
	OperationStatus,
} from "../../Communication/Constants";
import { GET_TOKEN_ACTION } from "./Constants";

export default class InvitationHandlerAction extends BaseCommunication {
	getToken(accessId, timezone, callback) {
		let requestFormBody = {
			web_token: accessId,
			timezone: timezone
		}
		this.callAPI(GET_TOKEN_ACTION, API_BASE_URL + API_URL.GET_TOKEN, HttpMethod.POST, requestFormBody,
			(apiResponse) => {
				if (apiResponse.status === OperationStatus.SUCCESS) {
					if (apiResponse.data !== null) {
						store.dispatch({
							type: GET_TOKEN_ACTION,
							response: apiResponse.data.data,
						});
					}
				}
				callback(apiResponse);
			}
		);
	}
}
